<template>
  <div class="sponsorship">
    <b class="sponsorship-small-head" :style="'color:'+landingPage.textColor">{{value.title}}</b>
    <div v-if="value.title.length>1" class="small-green-line" :style="'background:'+landingPage.themeColor"></div>
    <div class="logos-wrap">
      <div v-for="(logo,i) in value.imageGallery" :key="i" :class="'logo-'+logosize">
        <img :src="logo.imageURL" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Sponsers",
  props: {
    value: Object,
    landingPage: Object
  },
  computed: {
    logosize() {
      if (this.value.logoSize) {
        return this.value.logoSize.value.toLowerCase();
      } else {
        return "mid";
      }
    },
  },
};
</script>
